module.exports = __webpack_public_path__ + "img/t13.e2bebca1.jpg";